module.exports = __webpack_public_path__ + "img/ios_btn.ce5f21a5.png";